module.exports = __webpack_public_path__ + "fonts/Cascadia-Code-Regular-2.b55aa533.ttf";